/* Optional JS for SAISHO GEAR Button System */
(function () {
  function eventElement(event) {
    return event.target instanceof Element ? event.target : null;
  }

  function clampQuantity(input) {
    const min = Number(input.getAttribute('min') || 1);
    const max = Number(input.getAttribute('max') || Infinity);
    let value = Number(input.value || min);
    if (Number.isNaN(value)) value = min;
    input.value = Math.max(min, Math.min(max, value));
  }

  document.addEventListener('click', function (event) {
    const target = eventElement(event);
    const button = target && target.closest('.sg-qty-btn');
    if (!button) return;

    const qty = button.closest('.sg-qty');
    const input = qty && qty.querySelector('.sg-qty-input');
    if (!input) return;

    const isIncrease = button.textContent.trim() === '+' || button.dataset.action === 'increase';
    const current = Number(input.value || input.getAttribute('min') || 1);
    input.value = current + (isIncrease ? 1 : -1);
    clampQuantity(input);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (event) {
    const target = eventElement(event);
    if (target && target.matches('.sg-qty-input')) clampQuantity(target);
  });

  document.addEventListener('click', function (event) {
    const target = eventElement(event);
    const pressedButton = target && target.closest('[data-sg-toggle]');
    if (!pressedButton) return;

    const group = pressedButton.closest('[data-sg-toggle-group]');
    if (group) {
      group.querySelectorAll('[data-sg-toggle]').forEach(function (btn) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      });
    }

    pressedButton.classList.add('is-active');
    pressedButton.setAttribute('aria-pressed', 'true');
  });
})();
